export default __webpack_public_path__ + "static/media/Settings.f88667f2.svg";